import React, {useMemo, memo} from 'react';
import {Props} from './ac-empty-block.proptypes';
import {Fade} from 'react-awesome-reveal';
import clsx from 'clsx';

// Imports => Constants
import {ICONS} from '@asdf-constants';

// Imports => Atoms
import {AcIcon} from '@asdf-atoms/ac-icon';

const _CLASSES = {
  MAIN: 'ac-empty-block',
  DENSE: 'ac-empty-block--dense',
  BORDER: 'ac-empty-block--border',
  CONTENT: 'ac-empty-block__content',
  ICON: 'ac-empty-block__icon',
  MESSAGE: 'ac-empty-block__message',
};

const AcEmptyBlock = memo(
  ({
    message = 'No data found to display.',
    dense = false,
    border = true,
    icon = ICONS.UNAVAILABLE,
    className,
  }) => {
    const getMessageClassNames = useMemo(() => {
      return clsx(_CLASSES.MESSAGE);
    }, []);

    const getIconClassNames = useMemo(() => {
      return clsx(_CLASSES.ICON);
    }, []);

    const getContentClassNames = useMemo(() => {
      return clsx(_CLASSES.CONTENT);
    }, []);

    const getMainClassNames = useMemo(() => {
      return clsx(_CLASSES.MAIN, dense && _CLASSES.DENSE, border && _CLASSES.BORDER, className);
    }, [dense, border, className]);

    return (
      <Fade duration={200} appear>
        <div className={getMainClassNames}>
          <div className={getContentClassNames}>
            <AcIcon icon={icon} className={getIconClassNames} />
            <p
              className={getMessageClassNames}
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          </div>
        </div>
      </Fade>
    );
  }
);

AcEmptyBlock.displayName = 'AcEmptyBlock';
AcEmptyBlock.propTypes = Props;

export {AcEmptyBlock};
export default AcEmptyBlock;
